import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExchangeRate } from '@emi/shared/models';

export interface DialogData {
    selectedCurrency: string;
    exchangeRateData: ExchangeRate[];
}

@Component({
    selector: 'exchange-rate-modal',
    templateUrl: './exchange-rate-modal.component.html',
    styleUrls: ['./exchange-rate-modal.component.scss'],
})
export class ExchangeRateModal {
    constructor(public dialogRef: MatDialogRef<ExchangeRateModal>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

    public exchangeRates: any[] = [];
    public selectedCurrency: string = 'USD';

    public closeClicked(): void {
        this.dialogRef.close();
    }
}
